import PageTitle from "../general/PageTitle";
import DashboardLink from "../general/links/DashboardLink";
import CurrentPage from "../general/links/CurrentPage";
import CustomerStatementForm from "./CustomerStatementForm"

// Render Customer Statement page
export default function CustomerStatement(){
  return (
    <>
      {/* Title */}
      <PageTitle title={"Your Customer Statements"} />
      {/* Link */}
      <div style={{ display: "flex" }}> 
          <DashboardLink/>
          <CurrentPage currentPage={"Customer Statements"} />
      </div>
      {/* Customer Statement Form */}
      <CustomerStatementForm />
    </>
  )
}